import o from "./index.ce.vue2.js";
import t from "./index.ce.vue3.js";
import e from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ e(o, [["styles", [t]]]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/userSelectedDialog/index.ce.vue.js
// module id = 1293
// module chunks = 41